<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd10">
      <div id="search-land">
        <h3 class="title">
          {{'Find land'|translate}}
          <a  v-on:click="handleShowModal(null)">
            <i class="fas fa-pencil-alt"></i>
            {{'Add'|translate}}
          </a>
        </h3>
        <div class="row">
          <div class="col-md-4">
            <p class="mobile-search-toggle visible-xs" v-on:click="hide_mobile = !hide_mobile">
              {{'Search'|translate}}
              <i class="fas fa-angle-down" v-if="hide_mobile"></i>
              <i class="fas fa-angle-up" v-if="!hide_mobile"></i>
            </p>
            <div class="search-controls mt10" v-bind:class="{'hidden-xs':hide_mobile}">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <p class="all-types">
                    <a
                      v-for="(item) in types"
                      :key="item.id"
                      v-bind:class="{active:search_params.type_id == item.id}"
                      v-on:click="changeType(item.id)"
                    >{{ item.name }}</a>
                  </p>
                </div>
                <!-- begin panel-body -->
                <div class="panel-body">
                  <form v-on:submit.prevent="doSearch">
                    <div class="row">
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <select
                            class="form-control"
                            v-model="search_params.province_id"
                            @change="onSelectProvince"
                          >
                            <option value>{{'All provinces'|translate}}...</option>
                            <option
                              v-for="item in list_provinces"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <select
                            class="form-control"
                            v-model="search_params.district_id"
                            @change="onSelectDistrict"
                          >
                            <option value>{{'All districts'|translate}}...</option>
                            <option
                              v-for="item in list_districts"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <select class="form-control" v-model="search_params.commune_id">
                            <option value>{{'All communes'|translate}}...</option>
                            <option
                              v-for="item in list_communes"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="input-group wrap-query">
                          <input
                            type="text"
                            class="search-query form-control"
                            placeholder="Từ khóa"
                            v-model="search_params.keyword"
                          />
                          <span class="input-group-btn">
                            <button class="btn btn-danger transparent" type="button">
                              <span class="glyphicon glyphicon-search"></span>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- end row -->
                    <div class="mt20"></div>
                    <div class="row">
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <select class="form-control" v-model="search_params.price">
                            <option value>{{'All prices (price_unit)'|translate}}...</option>
                            <option
                              v-for="item in prices"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="form-group">
                          <select class="form-control" v-model="search_params.area">
                            <option value>{{'All areas (m2)'|translate}}...</option>
                            <option
                              v-for="item in areas"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12" v-if="user">
                        <input type="checkbox" id="search-my-post" v-model="search_params.my_post" />
                        <label
                          class="no-bold"
                          for="search-my-post"
                        >{{ 'Search my post' |translate }}</label>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6 mt10">
                        <button type="submit" class="btn btn-success full-width">
                          <i class="fas fa-search"></i>
                          {{'Search'|translate}}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <!-- end panel-body -->
              </div>
            </div>
            <!-- end search controls -->
          </div>
          <div class="col-md-8">
            <div class="list-results">
              <loading class="mt10" :text="'Please wait'|translate" v-if="list_items ===null"></loading>
              <p
                class="mt10 alert alert-info"
                v-if="list_items && list_items.length == 0"
              >{{'No result'|translate}}</p>
              <div v-if="list_items && list_items.length >0">
                <div class="item" v-for="item in list_items" :key="item.id">
                  <div class="image">
                    <img v-if="!item.thumb_feature_image" src="static/images/no-photo.jpg" />
                    <img v-if="item.thumb_feature_image" :src="item.thumb_feature_image" />
                    <div class="count">{{item.count_images}}</div>
                  </div>
                  <div class="item-body">
                    <router-link
                      :to="{ name: 'LandDetail', params: { slug: item.slug,id:item.id }}"
                    >{{item.title}}</router-link>
                    <p>
                      <span v-if="item.price" class="price">{{toCommas(item.price)}} đ</span>
                      {{toCommas(item.area)}} m2
                    </p>
                    <p
                      class="address"
                    >{{item.commune_name}}, {{item.district_name}}, {{item.province_name}}</p>
                    <div class="meta">
                      <p>{{ item.add_date | moment("from", "now") }}</p>
                    </div>
                  </div>
                  <div class="wrap-dropdown">
                    <mydropdown :ref="item.refDropdown">
                      <div slot="button">
                        <span
                          class="dropdown-toggle"
                          data-toggle="dropdown"
                          v-on:click="$refs[item.refDropdown][0].toogle()"
                        >
                          <i class="fas fa-ellipsis-h fa-lg"></i>
                        </span>
                      </div>
                      <ul slot="body" class="dropdown-menu dropdown-menu-right">
                        <li v-on:click="copyLink(item)">
                          <a>
                            <i class="far fa-copy"></i>
                            {{'Copy link'|translate}}
                          </a>
                        </li>
                        <li v-if="user && user.id == item.user_id">
                          <a v-on:click="updateItem(item)">
                            <i class="fas fa-edit"></i>
                            {{'Update'|translate}}
                          </a>
                        </li>
                        <li v-if="user && user.id == item.user_id">
                          <a v-on:click="removeAd(item)">
                            <i class="fas fa-times"></i>
                            {{'Remove'|translate}}
                          </a>
                        </li>
                      </ul>
                    </mydropdown>
                  </div>
                </div>
                <!-- end .item  -->
                <paginate
                  v-if="total_page > 1"
                  :page-count="total_page"
                  :click-handler="clickPage"
                  :prev-text="'Prev'|translate"
                  :next-text="'Next'|translate"
                  v-model="page"
                  :container-class="'pagination'"
                ></paginate>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end search-land -->
      <div v-if="show_form">
        <form-land ref="formLand" :pass_data="pass_data" @modalData="modalData"></form-land>
      </div>
    </div>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Paginate from 'vuejs-paginate'
import Loading from '@/components/elements/Loading'
import FormLand from '@/components/Land/FormLand'
import mydropdown from 'vue2-bootstrap-dropdown'

export default {
  name: 'FindLand',
  components: {
    MyHeader,
    Paginate,
    Loading,
    FormLand,
    mydropdown
  },
  data () {
    return {
      user: null,
      list_items: null,
      hide_mobile: true,
      page: 1,
      total_page: 1,
      list_provinces: [],
      show_form: false,
      pass_data: null,
      list_districts: [],
      list_communes: [],
      types: [
        { id: '', name: this.$t('All') },
        { id: '1,2', name: this.$t('Buy/Sell') },
        { id: '3', name: this.$t('Lease') },
        { id: '4', name: this.$t('Cooperate') }
      ],
      prices: [
        { id: '<5000000', name: this.$t('Under') + ' 5,000,000' },
        { id: '<10000000', name: this.$t('Under') + ' 10,000,000' },
        { id: '<50000000', name: this.$t('Under') + ' 50,000,000' },
        { id: '<100000000', name: this.$t('Under') + ' 100,000,000' },
        { id: '<500000000', name: this.$t('Under') + ' 500,000,000' },
        { id: '<1000000000', name: this.$t('Under') + ' 1000,000,000' },
        { id: '>1000000000', name: this.$t('Over') + ' 1000,000,000' }
      ],
      areas: [
        { id: '<50', name: this.$t('Under') + ' 50' },
        { id: '<100', name: this.$t('Under') + ' 100' },
        { id: '<500', name: this.$t('Under') + ' 500' },
        { id: '<1000', name: this.$t('Under') + ' 1,000' },
        { id: '<5000', name: this.$t('Under') + ' 5,000' },
        { id: '>5000', name: this.$t('Over') + ' 5,000' }
      ],
      search_params: {
        type_id: '',
        keyword: '',
        limit: Utils.getLimit(),
        province_id: '',
        district_id: '',
        commune_id: '',
        price: '',
        offset: 0,
        area: ''
      }
    }
  },
  methods: {
    copyLink (item) {
      let str = Utils.getBaseUrl() + `/land/${item.slug}/${item.id}`
      Utils.sendToClipboard(str)
      this.$alertify.success(this.$t('Copied link'))
    },
    updateItem (item) {
      this.showModal(item)
    },
    removeAd (item) {
      this.$alertify.confirmWithTitle(
        this.$t('Confirm'),
        this.$t('Are you sure to remove this ad ?'),
        () => {
          Utils.request(this, true, 'landmarket')
            .delete(`/manageLand/${item.id}`)
            .then(response => {
              this.doSearch()
            })
        }
      )
    },
    handleShowModal () {
      if (this.user) {
        this.showModal(null)
      } else {
        this.$router.push({
          name: 'Login'
        })
        // Utils.showLoginZalo()
      }
    },
    showModal (data) {
      console.log(data)
      // if (!data) {
      //   return this.$alertify.alertWithTitle(
      //     this.$t('Confirm'),
      //     this.$t('You need to update your phone to use this function')
      //   )
      // }
      this.show_form = false

      setTimeout(() => {
        this.show_form = true
        this.pass_data = data != null ? JSON.parse(JSON.stringify(data)) : data

        setTimeout(() => {
          this.$refs.formLand.open()
        })
      })
    },
    changeType (type_id) {
      this.search_params.type_id = type_id
      this.doSearch()
    },
    getProvines () {
      Utils.request(this, true, 'landmarket')
        .get(`/listProvinces/`)
        .then(response => {
          this.list_provinces = response.data.data.list
          // console.log('this.list_provinces',this.list_provinces)
        })
    },
    onSelectProvince (e) {
      e.preventDefault()
      console.log('on change province', this.search_params.province_id)
      this.getDistricts()
    },
    getDistricts () {
      this.list_districts = []
      this.list_communes = []

      this.search_params.district_id = ''
      this.search_params.commune_id = ''
      this.getListDistricts()
    },
    getListDistricts () {
      Utils.request(this, true, 'landmarket')
        .get(`/listDistricts/${this.search_params.province_id}`)
        .then(response => {
          this.list_districts = response.data.data.list
          // console.log('this.list_districts',this.list_districts)
        })
    },
    onSelectDistrict () {
      console.log('on change district', this.search_params.district_id)
      this.getCommunes()
    },
    getCommunes () {
      this.list_communes = []
      this.search_params.commune_id = ''

      this.getListCommune()
    },
    getListCommune () {
      Utils.request(this, true, 'landmarket')
        .get(`/listCommunes/${this.search_params.district_id}`)
        .then(response => {
          this.list_communes = response.data.data.list
        })
    },
    doSearch () {
      this.search_params.offset = 0
      this.search()
    },
    modalData (data) {
      console.log('data', data)
      this.doSearch()
    },
    search () {
      this.list_items = null
      Utils.request(this, true, 'landmarket')
        .get(`/searchLand/?${Utils.arrayToRequestParam(this.search_params)}`)
        .then(response => {
          let data = response.data
          if (data.status === 'ok') {
            let list = data.data.list
            list = list.map(item => {
              let temp = new Date(parseInt(item.add_time) * 1000)
              item.add_date = this.$moment(temp)
              item.refDropdown = 'dropdown' + item.id
              return item
            })
            this.list_items = list
            this.total_page = Utils.getTotalPages(data.data.total)
          }
        })
        .catch(error => {
          this.updating = false
          Utils.showErrorMessage(this, error.response)
        })
    },
    toCommas (value) {
      return Utils.toCommas(value)
    },
    clickPage (pageNum) {
      this.search_params.offset = Utils.getNextOffset(pageNum)
      this.search()
    }
  },
  mounted () {
    this.user = Utils.getUser(this)
    this.getProvines()
    this.search()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Land/LandMarket.vue